// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"15bce642","787":"15b6993d"}[chunkId] + ".chunk.js";
};